import React, { Component } from 'react';
import path from 'path';
import LinkedPage from './components/pageState/LinkedPage';

class App extends Component {
  render() {
    return (
      <div className="App">
        <LinkedPage />
      </div>
    )
  };

}

export default App;